import { FC } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Message, Messages } from "../../../../../../../shared/chat/messages";
import { message } from "antd";
import { ComponentQueryLoader } from "../../../../../../../shared/component-query-loader";
import {
  CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Document,
  CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateDocument,
  SendReportCaseV1UpdateInput,
} from "../../../../../../../../generated";

interface CaseDetailsMessagesContainerProps {
  caseId: string;
}

export const CaseDetailsMessagesContainer: FC<CaseDetailsMessagesContainerProps> = (props) => {
  const {
    data: queryData,
    loading,
    error,
  } = useQuery(
    CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
    }
  );

  const { startPolling, stopPolling, data: pollingData } = useQuery(CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
    }
  );

  const [updatedMessages] = useMutation(
    CasesSendReportV1CaseDetailsMessagesContainerSendReportCaseV1UpdateDocument
  );

  const handleSave = async (values: any) => {

    const inputData: SendReportCaseV1UpdateInput = {
      id: props.caseId,
      messages: values?.messages,
    };

    if (values?.revisionRequest) {
      inputData.revisionRequest = {
        ...values?.revisionRequest,
      };
    }

    if(values?.financeDetails){
      inputData.financeDetails = {
        ...values?.financeDetails,
      };
    }
    if (values?.adhocPayment) {
      inputData.adhocPayment = {
        ...values?.adhocPayment,
      };
    }
    try {
      const result = await updatedMessages({
        variables: {
          input: inputData,
        },
      });
      if (result.data?.sendReportCaseV1Update?.status.success) {
        message.success("Message sends successfully");
      } else {
        message.error(
          `Error in sending message: ${result.data?.sendReportCaseV1Update?.status.errorMessage}`
        );
      }
    } catch (error) {
      message.error(`Error in sending message: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      error={error}
      loading={loading}
      hasData={queryData?.sendReportCaseV1}
      hasDataComponent={
        <Messages
          disabled={queryData?.sendReportCaseV1?.state === 'decisionRendered'}
          caseId={props.caseId}
          data={{
            messages: queryData?.sendReportCaseV1?.messages as Message[],
            applicant: {
              restOfName: queryData?.sendReportCaseV1?.applicant?.personalInformation?.identityDetails?.restOfName as string,
              lastName: queryData?.sendReportCaseV1?.applicant?.personalInformation?.identityDetails?.lastName as string,
            }
          }}
          onSave={handleSave}
          startPollingMessages={startPolling}
          pollingMessagesData={{ data: { id: pollingData?.sendReportCaseV1?.id, messages: pollingData?.sendReportCaseV1?.messages as Message[] } }}
          stopPollingMessages={stopPolling}
          updateMessage={() => {} }
          transactions={queryData?.sendReportCaseV1?.financeDetails?.transactions} cyberSourcePublicKey={undefined} applicantId={undefined}
          paymentInstrument={{
            billTo: undefined,
            cardNumber: undefined,
            cardType: undefined,
            expirationMonth: undefined,
            expirationYear: undefined,
            id: undefined,
            paymentInstrumentId: undefined,
            state: undefined
          }}
          country={[]}        />
      }
    />
  );
};
